export const initialState = {};

/**
 * Handles redux state for app details
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function appReducer(state = initialState, action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

export default appReducer;
